const wrapper = "_arawx3264o";
const checkmark = "_arac17thy2t";

export { checkmark, wrapper };
import "./atom.checkmark.style.linaria.module.css";
//# sourceMappingURL=atom.checkmark.style.js.map
